<template>
    <v-alert
        class="ma-2"
        icon="mdi-account-cog-outline"
        prominent
        text
        type="info">
            Non sono presenti impostazioni configurabile per {{ model }} per il momento.
    </v-alert>  
</template>

<script>
export default {
    name: 'contractcodes-settings',
    props: {
        model: {
            type: String,
            required: true
        }
    },
}
</script>